import { FC, PropsWithChildren } from 'react'
import { Variants } from 'motion/react'
import { ThemeProvider } from 'styled-components'
import GlobalStyles from '../styles/Global'
import theme from '../styles/theme'
import Demo from './Demo'
import * as app from '../styles/App.styled'
import * as styledLogo from '../styles/Logo.styled'
import logo from '../assets/logo.svg'

export const App: FC = () => {
  const TemplateLink: FC<PropsWithChildren> = ({
    children,
  }) => {
    return (
      <app.StyledLink
        href='https://www.npmjs.com/package/@epic-effx/create-epic-graphql-server'
        rel='noreferrer'
        target='_blank'
      >
        {children}
      </app.StyledLink>
    )
  }

  const slideInVariants: Variants = {
    hidden: {
      x: 200,
      opacity: 0,
    },
    visible: (index: number) => ({
      x: 0,
      opacity: 1,
      transition: {
        delay: index * 0.5,
        duration: 0.6,
        ease: 'easeOut',
      },
    }),
  }

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <app.StyledContainer>
        <app.StyledHeader>
          <h1>Create Epic GraphQL Server</h1>
          <h2>Tap into the powerful GraphQL API query language!</h2>
          <h2>
            <>Build your GraphQL server now using&nbsp;</>
            <TemplateLink>CEGS</TemplateLink>
          </h2>
        </app.StyledHeader>
        <app.StyledSection>
          <styledLogo.StyledContainer>
            {[0, 1].map(i => (
              <styledLogo.StyledLogo
                key={i}
                src={logo}
                alt={`Logo ${i + 1}`}
                initial='hidden'
                animate='visible'
                variants={slideInVariants}
                custom={i}
              />
            ))}
          </styledLogo.StyledContainer>
        </app.StyledSection>
        <app.StyledSection>
          <Demo />
        </app.StyledSection>
      </app.StyledContainer>
    </ThemeProvider>
  )
}
